import script from "./RestartAccountCompleteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestartAccountCompleteView.vue?vue&type=script&lang=ts&setup=true"

import "./RestartAccountCompleteView.vue?vue&type=style&index=0&id=3e2bebd8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2bebd8"]])

export default __exports__